module.exports = __webpack_public_path__ + "static/media/light-icon.b8b74ed7.svg";